import { useCollection } from './use-swr-collection';
/**
 *
 * 🚨 Experimental. I recommend only using this only to test for now. There are some edge cases still being figured out for caching collection groups.
 */

export const useExperimentalCollectionGroup = (collection, query, swrOptions) => {
  console.warn('[swr-firestore] useExperimentalCollectionGroup is deprecated. Switch to useCollectionGroup.');
  return useCollection(collection, { ...query,
    isCollectionGroup: true
  }, swrOptions);
};
export const useCollectionGroup = (collection, query, swrOptions) => {
  return useCollection(collection, { ...query,
    isCollectionGroup: true
  }, swrOptions);
};
//# sourceMappingURL=use-swr-collection-group.js.map